import { useState, useCallback } from 'react'

const useHover = () => {
  const [hover, setHover] = useState()
  const onHover = useCallback(() => {
    setHover(true)
  }, [])
  const onBlur = useCallback(() => {
    setHover(false)
  }, [])

  return { hover, onBlur, onHover }
}

export default useHover
